var map = {
	"./alrajhi_golf/icon-registry.ts": [
		30646,
		646
	],
	"./cbd_golf_v2/icon-registry.ts": [
		57128,
		7128
	],
	"./eib/icon-registry.ts": [
		2354,
		2354
	],
	"./hdfc_bundle/icon-registry.ts": [
		66085,
		6085
	],
	"./hsbc_beach_club/icon-registry.ts": [
		24038,
		4038
	],
	"./hsbc_live/icon-registry.ts": [
		21616,
		1616
	],
	"./icici_golf/icon-registry.ts": [
		1302,
		1302
	],
	"./incred/icon-registry.ts": [
		46932,
		6932
	],
	"./marketplace/icon-registry.ts": [
		42273,
		2273
	],
	"./mashreq/icon-registry.ts": [
		5850,
		5850
	],
	"./mastercard_airdine/icon-registry.ts": [
		88462,
		8462
	],
	"./mastercard_contactless/icon-registry.ts": [
		51825,
		1825
	],
	"./mastercard_fab/icon-registry.ts": [
		66546,
		6546
	],
	"./mastercard_uae/icon-registry.ts": [
		44492,
		4492
	],
	"./nbf/icon-registry.ts": [
		48779,
		8779
	],
	"./scb/icon-registry.ts": [
		10613,
		613
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 86529;
module.exports = webpackAsyncContext;